<template>
  <TenderStep
    :current-step="currentStep"
    :total-steps="totalSteps"
    :error-transition="false"
  >
    <template slot="header">
      <div class="text-base font-normal text-[#4a4a4a]">
        {{
          newTender.name.value ||
          $t("requestTender.email.header.nameDefaultValue")
        }},
      </div>
      <div class="question-big">
        {{ $t("requestTender.email.question") }}
      </div>
      <span class="text-base font-normal text-[#4a4a4a]">{{
        $t("requestTender.email.header.theTenders")
      }}</span>
    </template>

    <div class="relative">
      <JoszakiInput
        ref="emailInput"
        v-model="newTender.email.value"
        name="email"
        type="text"
        :placeholder="$t('requestTender.email.placeholder')"
        autofocus
        :show-error-msg="false"
        :validation-state="emailValidation"
        @keypress="forceKeyPressLowercase"
        @blur="emailValidation.$touch()"
        @keyup.enter.exact.native="emitNext('enter')"
      />
      <span
        v-if="!emailValidation.$invalid"
        class="absolute right-3 top-1/2 -translate-y-1/2 text-positive pointer-events-none"
      >
        <IconComponent class="fa-lg" icon="check" />
      </span>
    </div>

    <template slot="error">
      <div v-if="emailValidation.$error">
        {{ emailValidation.$errors[0]?.$message }}
      </div>
    </template>

    <template slot="footer">
      <WizardNextButton
        :disabled="emailValidation.$invalid"
        @click="emitNext()"
      />
    </template>
  </TenderStep>
</template>

<script>
import { toRefs } from "@nuxtjs/composition-api";
import WizardNextButton from "./WizardNextButton.vue";
import TenderStep from "@/components/TenderStep";
import { useNewTender } from "~/composables/tender/useNewTender";
import { useTrackWizardClick } from "~/composables/tracking/useTrackWizardClick";
import { useForceLowerCase } from "~/composables/forceLowerCase";

export default {
  name: "EmailStepModule",
  components: { TenderStep, WizardNextButton },
  props: {
    currentStep: { type: Number, required: true },
    totalSteps: { type: Number, required: true },
    moduleSlug: { type: String, default: "email" },
  },
  emits: ["next"],
  setup(props) {
    const { trackNextAttempt } = useTrackWizardClick(toRefs(props));
    return {
      trackNextAttempt,
      newTender: useNewTender(),
      ...useForceLowerCase(),
    };
  },
  computed: {
    emailValidation() {
      return this.newTender.v$.value.email;
    },
  },
  methods: {
    emitNext(trigger = "click") {
      this.trackNextAttempt({
        trigger,
        disabled: this.emailValidation.$invalid,
      });
      if (this.emailValidation.$invalid) {
        this.emailValidation.$touch();
        return;
      }
      this.newTender.saveToStorage();
      this.$emit("next", { field: "email" });
    },
  },
};
</script>
